import { FilterTypes } from '@carboledger/ui';
import { buildAllocationPreferenceOptions } from '@/config/formOptions';
import { customerFilter, materialFilter } from '@/config/filterDefinitions';
import { ALLOCATION_STATUS } from './allocationStatus';

// `status` and `daysLeft` await their server support; the rest are FulfillmentFilters fields.
export const ALLOCATION_FILTERS = Object.freeze({
  status: 'status',
  materialId: 'materialId',
  customerAccountId: 'customerAccountId',
  daysLeft: 'daysLeft',
  allocationPreference: 'allocationPreference',
});

// The five the filter panel offers — Pending shipment and Revoked are deliberately not among them.
const STATUS_LABEL_KEYS = Object.freeze({
  [ALLOCATION_STATUS.pendingDeclaration]: 'ALLOCATIONS_STATUS_PENDING_DECLARATION',
  [ALLOCATION_STATUS.creditsRetired]: 'ALLOCATIONS_STATUS_CREDITS_RETIRED',
  [ALLOCATION_STATUS.declarationGenerated]: 'ALLOCATIONS_STATUS_DECLARATION_GENERATED',
  [ALLOCATION_STATUS.declarationUpdated]: 'ALLOCATIONS_STATUS_DECLARATION_UPDATED',
  [ALLOCATION_STATUS.declarationRejected]: 'ALLOCATIONS_STATUS_DECLARATION_REJECTED',
});

const DAYS_LEFT_LABEL_KEYS = Object.freeze({
  1: 'ALLOCATIONS_FILTER_DAYS_LEFT_1',
  3: 'ALLOCATIONS_FILTER_DAYS_LEFT_3',
  5: 'ALLOCATIONS_FILTER_DAYS_LEFT_5',
  7: 'ALLOCATIONS_FILTER_DAYS_LEFT_WEEK',
});

const toOptions = (labelKeys, t) =>
  Object.entries(labelKeys).map(([value, key]) => ({ value, label: t(key) }));

export const buildAllocationFilterDefinitions = (t, { materialOptions, customerOptions } = {}) => [
  {
    field: ALLOCATION_FILTERS.status,
    label: t('FIELD_STATUS'),
    type: FilterTypes.checkbox,
    options: toOptions(STATUS_LABEL_KEYS, t),
  },
  ...materialFilter(t, ALLOCATION_FILTERS.materialId, materialOptions),
  ...customerFilter(t, ALLOCATION_FILTERS.customerAccountId, customerOptions),
  {
    field: ALLOCATION_FILTERS.daysLeft,
    label: t('FIELD_DAYS_LEFT'),
    type: FilterTypes.checkbox,
    options: toOptions(DAYS_LEFT_LABEL_KEYS, t),
  },
  {
    field: ALLOCATION_FILTERS.allocationPreference,
    // Single-select, not checkbox: the route matches `preferred_allocation` against one value.
    type: FilterTypes.select,
    label: t('ALLOCATIONS_COL_ALLOCATED_QUOTA'),
    options: buildAllocationPreferenceOptions(t),
  },
];
